import { useNavigate } from "react-router-dom";
import PlusIconSVG from "../../../SharedComponents/assets/icons/svg/PlusIconSVG";
import BaseButton from "../../../SharedComponents/components/Buttons/BaseButton";
import { ButtonVariantEnum } from "../../../SharedComponents/utils/enums/ButtonVariantEnum";
import { FontEnum } from "../../../SharedComponents/utils/enums/FontEnum";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getUserFilterCount } from "../../reduxStore/entities/userFilter";
import { getPartRequestCount } from "../../reduxStore/entities/partRequest";

const NoActiveRequests = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const fetchedUserFilterCount = useSelector((state) => state.userFilter.userFilterCount);
    const isLoaded = useSelector((state) => state.userFilter.isLoaded);

    const fetchedPartRequestCount = useSelector((state) => state.partRequest.partRequestCount);
    const partRequestCountLoaded = useSelector((state) => state.partRequest.isLoaded);


    useEffect(() => {
        dispatch(getUserFilterCount());
        dispatch(getPartRequestCount());
    }, []);

    if (!isLoaded || !partRequestCountLoaded) {
        return null;
    };


    const GetInstructionDiv = (serial, desc) => {
        return (
            <div style={styles.insturctionContainer}>
                <div style={styles.serialContainer}>
                    <p style={styles.serialText}>
                        {serial}
                    </p>
                </div>
                <p style={styles.descText}>
                    {desc}
                </p>
            </div>
        );
    };

    const PlusIconSVGWhite = () => {
        return (
            <PlusIconSVG fill="#FFFFFF" />
        );
    };

    const getSellerCountString = () => {
        let secondWord = "prodavaca";

        const numString = fetchedUserFilterCount.toString();
        const lastDigit = numString.charAt(numString.lenght - 1);

        if (lastDigit === "1") {
            secondWord = "prodavac";
        };

        return `${fetchedUserFilterCount} ${secondWord} ima deo za tvoj auto`;
    };

    const getUserWhoOrderedCountString = () => {
        let secondWord = "korisnika";
        const numString = fetchedPartRequestCount.toString();
        const lastDigit = numString.charAt(numString.lenght - 1);

        if (lastDigit === "1") {
            secondWord = "korisnik";
        };

        return `${fetchedPartRequestCount} ${secondWord} je naručilo delove preko SmartPart platforme`;
    };

    return (
        <div style={styles.mainContainer}>

            <div style={styles.titlesContainer}>
                <p style={styles.title}>
                    {getSellerCountString()}
                </p>

                <p style={styles.title}>
                    {getUserWhoOrderedCountString()}
                </p>
            </div>


            <div style={styles.insturctionsContainer}>
                {GetInstructionDiv(1, "Unesi opis traženog dela")}

                <div style={styles.hrDiv} />

                {GetInstructionDiv(2, "Oglasi svoj zahtev")}

                <div style={styles.hrDiv} />

                {GetInstructionDiv(3, "Izaberi najbolju ponudu")}

            </div>


            <div style={styles.buttonContainer}>
                <BaseButton
                    onClick={() => navigate('/order-part')}
                    variant={ButtonVariantEnum.BLACK}
                    text={"Naruči deo"}
                    IconComponent={PlusIconSVGWhite}
                />
            </div>

        </div>
    );
};

export default NoActiveRequests;


const styles = {
    mainContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 50,
        padding: 30,
        backgroundColor: "rgb(243, 244, 246)",
        border: "1px solid rgb(203, 213, 225)",
        borderRadius: "8px",
        width: "50%",
    },
    titlesContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: 10
    },
    title: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "24px",
        color: "rgba(0, 0, 0, 0.87)",
        textAlign: "center"
    },
    insturctionsContainer: {
        flex: 1,
        display: 'flex',
        alignItems: 'center',
    },
    insturctionContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 20
    },
    serialContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: "24px",
        height: "24px",
        borderRadius: 12,
        backgroundColor: "rgb(156, 39, 176)"
    },
    serialText: {
        fontSize: "12px",
        color: "rgb(255, 255, 255)"
    },
    descText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontSize: "16px",
        color: "rgba(0, 0, 0, 0.87)",
        textAlign: 'center'
    },
    hrDiv: {
        flex: 1,
        height: "1px",
        backgroundColor: "rgb(189, 189, 189)"
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
};